module.exports = __webpack_public_path__ + "static/overlay-b1064c4765c61ed10a84a26382a3e085.jpg";